import { Injectable } from '@angular/core';
import {FormGroup} from "@angular/forms";
// @ts-ignore
import * as isEqual from 'lodash.isequal';

@Injectable({
  providedIn: 'root'
})
export class FormService {

  activeForms: FormGroup[] = [];
  defaultValues: any = new WeakMap();

  forceSkipCheck: boolean = false;

  constructor() { }

  setState(formGroup: FormGroup, controlsName: string[] = [], isEnabled: boolean): void {
    for(let name of controlsName) {
      const control = formGroup.get(name);

      isEnabled ? control.enable() : control.disable();
    }
  }

  setActiveForms(forms: FormGroup[]) {
    this.activeForms = forms;
  }

  setDefaultValues(form: FormGroup) {
    this.forceSkipCheck = false;
    this.defaultValues.set(form, form.getRawValue());
  }

  setForceSkipCheck() {
    this.forceSkipCheck = true;
  }

  getForceSkipCheck() {
    return this.forceSkipCheck;
  }

  checkChanges(form: FormGroup) {
    const defaultValue = this.defaultValues.get(form);
    const currentValue = form.getRawValue();

    return !isEqual(defaultValue, currentValue);
  }

  toggleControls(formGroup: FormGroup, formGroupModel: any, condition, model?: any) {
    for (let key in formGroupModel) {
      if (formGroupModel.hasOwnProperty(key)) {
        if (condition) {
          if (formGroup.contains(key)) return;
          if (model && model[key]) {
            formGroupModel[key].setValue(model[key])
          }
          formGroup.registerControl(key, formGroupModel[key]);
        } else if (formGroup.contains(key)) {
          formGroup.removeControl(key);
        }
      }
    }
  }

  parseIntAtParams(p: any) {
    let params = Object.assign({}, p);
    for (let key in params) {
      if (params.hasOwnProperty(key) && parseInt(params[key])) {
        params[key] = parseInt(params[key]);
      }
    }
    return params;
  }
}
